/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Sync_PeopleInputs */

const cs_calendar_sync_people = /** @type {(inputs: Calendar_Sync_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahrnout úkoly`)
};

const en_calendar_sync_people = /** @type {(inputs: Calendar_Sync_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include tasks of`)
};

/**
* | output |
* | --- |
* | "Include tasks of" |
*
* @param {Calendar_Sync_PeopleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_people = /** @type {((inputs?: Calendar_Sync_PeopleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_PeopleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_people(inputs)
	return cs_calendar_sync_people(inputs)
});